<template>
  <div>
    <Alert closable
      >个股单经纪商的持股比例变动，一定程度反映该经纪商背后的机构投资者对后市股价的态度</Alert
    >

    <h4 style="margin:20px auto; text-align:center">
      {{ stockName }} ({{ stockCode }}) {{ participantId }}
      {{ participantCN }} 券商持股趋势图
    </h4>
    <h2>
      <menu-title></menu-title>
    </h2>
    <div class="class-box">
      <p id="chart-1" :style="{ width: '100%', height: '600px' }"></p>
    </div>
  </div>
</template>
<script>
import menuTitle from "../components/menu-title";
import dayjs from "dayjs";
export default {
  components: {
    menuTitle
  },
  data() {
    return {
      dom: "",
      stockCode: "",
      stockName: "",
      participantEN: "",
      participantCN: "",
      participantId: "",
      list: [],
      echartOpt: {
        dataset: {
          source: []
        },

        tooltip: {
          trigger: "axis"
        },

        legend: {
          data: ["股价", "holding"]
        },
        toolbox: {
          feature: {}
        },
        grid: [
          {
            left: "8%",
            right: "8%",
            bottom: 200
          },
          {
            left: "8%",
            right: "8%",
            height: 80,
            bottom: 60
          }
        ],
        xAxis: [
          {
            type: "category"
          },
          {
            type: "category",
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            scale: true,
            name: "股价 （元）",
            axisLabel: {
              formatter: "{value}"
            }
          },
          {
            scale: true,
            name: "单位 （万元）",
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: {
              formatter: function(data) {
                return data / 10000;
              }
            }
          }
        ],
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: [0, 1],
            start: 60,
            end: 100
          },
          {
            show: true,
            xAxisIndex: [0, 1],
            type: "slider",
            bottom: 0,
            start: 30,
            end: 30,
            handleIcon:
              "M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
            handleSize: "105%"
          }
        ],

        series: [
          {
            type: "line",
            name: "股价",
            xAxisIndex: 0,
            yAxisIndex: 0
          },
          {
            name: "holding",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1
          }
        ]
      },
      title: ""
    };
  },
  methods: {
    async fetchData(stockCode, participantId) {
      const { data } = await this.$api.GetCassStockBrokerChangeDetail({
        stockCode,
        participantId
      });
      if (!data) {
        return;
      }
      this.stockCode = data.stockCode;
      this.stockName = data.name;
      this.participantId = data.participantId;
      this.participantEN = data.participantEN;
      this.participantCN = data.participantCN;
      this.echartOpt.dataset.source = data.holdingChange.map(i => {
        return [
          dayjs.unix(i.tradingDay).format("YYYY-MM-DD"),
          `${i.price}`,
          i.holding
        ];
      });
    }
  },
  async mounted() {
    // 必须要等dom挂在成功才可以使用echarts图表
    // 并且数据options必须赋值结束
    const stockCode = this.$route.params.code;
    const participantId = this.$route.params.cid;
    if (!stockCode || !participantId) {
      return;
    }
    await this.fetchData(stockCode, participantId);
    this.dom = document.getElementById("chart-1");
    const chart = echarts.init(this.dom);
    chart.setOption(this.echartOpt);
  },
  beforeDestroy() {
    echarts.dispose(this.dom);
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
